"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearingInputState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../i18n");
var number_input_state_1 = require("./number.input.state");
var BearingInputState = /** @class */ (function (_super) {
    tslib_1.__extends(BearingInputState, _super);
    function BearingInputState(label) {
        var _this = _super.call(this, label) || this;
        _this.precision = BearingInputState.DEGREE_PRECISION;
        _this.isLabelShown = false;
        return _this;
    }
    BearingInputState.equal = function (value1, value2) {
        var deg1 = core_shared_1.IkeAngle.toDegrees(value1);
        var deg2 = core_shared_1.IkeAngle.toDegrees(value2);
        return number_input_state_1.NumberInputState.equal(deg1, deg2, BearingInputState.DEGREE_PRECISION);
    };
    BearingInputState.prototype.formatInputValue = function (val) {
        var deg = core_shared_1.IkeAngle.toDegrees(val);
        return (deg != null && !isNaN(deg)) ? String(core_shared_1.IkeUnit.round(deg, this.precision)) : null;
    };
    BearingInputState.prototype.parseInputValue = function (val) {
        var num = this.parseNumber(val);
        if (num == null) {
            this.setError(null);
            return null;
        }
        if (isNaN(num)) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return null;
        }
        this.setError(null);
        return core_shared_1.IkeAngle.toRadians(num);
    };
    BearingInputState.prototype.parseNumber = function (val) {
        var RE_NUMBER = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
        if (val.trim().length === 0) {
            return null;
        }
        var lastChar = val.slice(-1);
        if (lastChar === '.') {
            val = val.slice(0, -1);
        }
        if (val.match(RE_NUMBER) == null) {
            return NaN;
        }
        return Number(val);
    };
    BearingInputState.DEGREE_PRECISION = 2;
    return BearingInputState;
}(number_input_state_1.NumberInputState));
exports.BearingInputState = BearingInputState;
//# sourceMappingURL=bearing.input.state.js.map